import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Route, Routes } from 'react-router';

import { AppLayout } from './components/AppLayout';
import { RequireAuth } from './components/RequireAuth';
import { CatalogPage } from './pages/CatalogPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { ModelTestPage } from './pages/ModelTestPage';
import { MoreAppsPage } from './pages/MoreAppsPage';
import { SettingsPage } from './pages/SettingsPage';
import { StoriesPage } from './pages/StoriesPage';
import { StoryDetailPage } from './pages/StoryDetailPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { UsersPage } from './pages/UsersPage';
import { WriteUsPage } from './pages/WriteUsPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          <Route path="stories" element={<StoriesPage />} />
          <Route path="stories/:id" element={<StoryDetailPage />} />
          <Route path="catalog" element={<Navigate to="/catalog/characters" replace />} />
          <Route path="catalog/:collection" element={<CatalogPage />} />
          <Route path="write-us" element={<WriteUsPage />} />
          <Route path="more-apps" element={<MoreAppsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="model-test" element={<ModelTestPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
}

function NotFound() {
  const { t } = useTranslation();

  return (
    <Center py="xl">
      <Stack align="center" gap="sm">
        <Title order={2}>{t('notFound.title')}</Title>
        <Text c="dimmed">{t('notFound.text')}</Text>
        <Button component={Link} to="/">
          {t('notFound.action')}
        </Button>
      </Stack>
    </Center>
  );
}
